import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=13a4e7b9&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a4e7b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13a4e7b9')) {
      api.createRecord('13a4e7b9', component.options)
    } else {
      api.reload('13a4e7b9', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=13a4e7b9&scoped=true&", function () {
      api.rerender('13a4e7b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cC5CrA7NNyXF/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports